import React, { useState } from 'react';
import { connect } from 'react-redux';
import ContentLayout from '../core/ContentLayout';
import I18n from '../../blocks/localization';
import { Button, Col, FormGroup, Input, Row } from 'reactstrap';
import Ddl from '../../models/common/Ddl';
import { MediumType } from '../../models/profile/MediumType';
import icon_baseline_error from '../../assets/icons/2x/baseline-error-24px.png';
import { Divider } from '@material-ui/core';
import icon_logged_in_user from '../../assets/icons/2x/icon_logirani-korisnik.png';
import { useHistory } from 'react-router-dom';
import PrometModal from '../shared/Modal';
import { ActivateFullProfileRequest } from '../../models/profile/ActivateProfileRequest';
import { ErrorMessage, Formik } from 'formik';
import { activateProfilePhysicalValidationSchema, activateProfileMobileValidationSchema } from '../../blocks/validation/validationSchema';
import { activateFullProfileActions } from '../../store/account/actions';
import TermsOfUseContent from './TermsOfUseContent';

type Props = typeof mapDispatchToProps;

const ActivateFullProfile = (props: Props) => {
    const initialActivateFullProfileRequest = { mediumType: MediumType.Physical, cardNumber: '', oib: '', verificationCode: '', areTermsAccepted: false } as ActivateFullProfileRequest;

    const history = useHistory();

    const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
    const [validationSchema, setValidationSchema] = useState<any>(activateProfilePhysicalValidationSchema);

    const termsModalClose = () => setIsTermsModalOpen(false);
    const termsModalOpen = () => setIsTermsModalOpen(true);

    const handleFormSubmit = (activateProfileRequest: ActivateFullProfileRequest) => {
        props.activateFullProfile(activateProfileRequest);
    }

    const mediumTypeOptions = [
        { id: MediumType.Physical, value: I18n.t('activateFullProfile.selectOptions.physical') },
        { id: MediumType.Mobile, value: I18n.t('activateFullProfile.selectOptions.mobile') },
    ] as Ddl[]

    return (
        <ContentLayout titleTranslateId='activateFullProfile.title'>
            <Divider />
            <Row>
                <Col xl={12} md={12} sm={12} className="mt-4">
                    <div>
                        <Row>
                            <Col xl={12} md={12} sm={12} className="mt-0 mb-0 d-flex align-items-center">
                                <div className="align-items-center justify-content-center">
                                    <img src={icon_logged_in_user} width="64" height="64" alt="User" />
                                </div>
                                <div className="pl-4">
                                    <span>{I18n.t('activateFullProfile.explanation')}</span>
                                </div>
                            </Col>
                        </Row>

                        <div className="mt-4 mb-4">
                            <span>{`${I18n.t('activateFullProfile.chooseMedium')}:`}</span>
                        </div>

                        <Formik
                            validationSchema={validationSchema}
                            validateOnBlur
                            initialValues={initialActivateFullProfileRequest}
                            enableReinitialize
                            onSubmit={(values) => handleFormSubmit(values)}>
                            {
                                ({ handleChange, handleSubmit, values, errors, touched }) => {
                                    return (
                                        <form onSubmit={handleSubmit}>
                                            <>
                                                <FormGroup>
                                                    <div className="mt-4 mb-2">
                                                        <div className='form-check' onClick={() => setValidationSchema(activateProfilePhysicalValidationSchema)}>
                                                            <label>
                                                                <Input onChange={handleChange} className='form-check-input' type="radio" value={mediumTypeOptions[0].id} name="mediumType" checked={values.mediumType == MediumType.Physical} /> {mediumTypeOptions[0].value}
                                                            </label>
                                                        </div>
                                                        <div className='form-check mt-2' onClick={() => setValidationSchema(activateProfileMobileValidationSchema)}>
                                                            <label>
                                                                <Input onChange={handleChange} className='form-check-input' type="radio" value={mediumTypeOptions[1].id} name="mediumType" checked={values.mediumType == MediumType.Mobile} /> {mediumTypeOptions[1].value}
                                                            </label>
                                                        </div>
                                                    </div>
                                                </FormGroup>

                                                <div className='d-flex justify-content-start align-items-center mt-4 mb-4'>
                                                    <span>{I18n.t(values.mediumType == MediumType.Physical ? 'activateFullProfile.infoPhysical' : 'activateFullProfile.infoMobile')}</span>
                                                    <span className='pl-2'><img src={icon_baseline_error} width="24" height="24" alt="!" /></span>
                                                </div>

                                                {
                                                    values.mediumType == MediumType.Physical &&
                                                    <FormGroup>
                                                        <div className='mt-4 mb-4'>
                                                            <Input onChange={handleChange} placeholder={I18n.t('activateFullProfile.cardNumberPlaceholder')} type="text" name="cardNumber"
                                                                className={errors.cardNumber && touched.cardNumber ? ' is-invalid' : ''} />
                                                            <ErrorMessage name="cardNumber" component="div" className="invalid-feedback" />
                                                        </div>
                                                        <div className='mt-4 mb-4'>
                                                            <Input onChange={handleChange} placeholder={I18n.t('activateFullProfile.oibPlaceholder')} type="text" name="oib"
                                                                className={errors.oib && touched.oib ? ' is-invalid' : ''} />
                                                            <ErrorMessage name="oib" component="div" className="invalid-feedback" />
                                                        </div>
                                                    </FormGroup>
                                                }

                                                {
                                                    values.mediumType == MediumType.Mobile &&
                                                    <FormGroup>
                                                        <div className='mt-4 mb-4'>
                                                            <Input onChange={handleChange} placeholder={I18n.t('activateFullProfile.activationCodePlaceholder')} type="text" name="verificationCode"
                                                                className={errors.verificationCode && touched.verificationCode ? ' is-invalid' : ''} />
                                                            <ErrorMessage name="verificationCode" component="div" className="invalid-feedback" />
                                                        </div>
                                                    </FormGroup>
                                                }

                                                <FormGroup className='mt-2'>
                                                    <input type="checkbox" name="areTermsAccepted" onChange={handleChange}
                                                        className={'mr-2' + (errors.areTermsAccepted && touched.areTermsAccepted ? ' is-invalid' : '')} />
                                                    <span>{I18n.t('activateFullProfile.agreement')}</span> &nbsp;
                                                    <span className="text-decoration-underline cursor-pointer" onClick={termsModalOpen}>{I18n.t('findOutMore')}</span>
                                                    <ErrorMessage name="areTermsAccepted" component="div" className="invalid-feedback" />
                                                </FormGroup>

                                                <Row>
                                                    <Col xl={12} className="mt-4 mb-4">
                                                        <Button type="button" color="primary" onClick={handleSubmit}>{I18n.t('activateFullProfile.activateButton')}</Button>
                                                        <span className='pl-3'>
                                                            <Button type="button" color="primary" outline onClick={() => history.goBack()} disabled={false}>{I18n.t('cancel')}</Button></span>
                                                    </Col>
                                                </Row>
                                            </>
                                        </form>
                                    );
                                }}
                        </Formik>
                    </div>
                </Col>
            </Row>
            <PrometModal
                isOpen={isTermsModalOpen}
                onOkClick={termsModalClose}
                onClose={termsModalClose}
                footer
                headerText={I18n.t('termsOfUse.title')}
                okText={I18n.t('close')}
                size='lg'
            >
                <TermsOfUseContent height='400px' />
            </PrometModal>
        </ContentLayout>
    );
}

const mapDispatchToProps = {
    activateFullProfile: activateFullProfileActions.request
};

export default connect(null, mapDispatchToProps)(ActivateFullProfile as any);
